var exports = {
  "g": "BaseCell__bNO_Fd",
};

module.exports = exports;
